module.exports = __webpack_public_path__ + "static/media/Vc520.529b5b4d.jpg";